module.exports = __webpack_public_path__ + "static/img/introduction-sustainability-se-accelerating-our-transition.56e87a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-sustainability-se-accelerating-our-transition.jpg
// module id = WFgb
// module chunks = 0